import * as React from "react";
import { Route } from 'react-router-dom';
import ResetPassword from '../user/ResetPassword';
const customRoutes =[
        <Route
            key="changeMyPwd"
            path="/api/user/changeMyPassword"        
            render={(routeProps) =>  <ResetPassword id={routeProps.match.params.id} typeCamp={routeProps.match.params.typeCamp}  {...routeProps} />}
        /> 
];

export default  customRoutes;